export const OUTREACH_GET_BY_CLIENT_AND_PROGRAM = 'OUTREACH_GET_BY_CLIENT_AND_PROGRAM';
export const OUTREACH_GET_BY_CLIENT_AND_PROGRAM_SUCCESS =
  'OUTREACH_GET_BY_CLIENT_AND_PROGRAM_SUCCESS';
export const OUTREACH_SAVE = 'OUTREACH_SAVE';
export const OUTREACH_ERROR = 'OUTREACH_ERROR';
